import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const PredictionDetail = Loadable({
  loader: () => import("./PredictionDetail"),
  loading: Loading
})
